(() => {
  'use strict';

  if (!window.location.pathname.includes('/products/')) return;
  if (window.__joaApoReadinessInstalled) return;
  window.__joaApoReadinessInstalled = true;
  let slowTimer, delayed = false, failed = false;

  const ACTION_SELECTOR = [
    '.joa-sticky-purchase',
    '.joa-product-form .mw-apo-add-to-cart-cloned',
    '.joa-product-form button[data-testid="standalone-add-to-cart"]',
    '.joa-product-form button[name="add"].add-to-cart-button',
    '.sticky-add-to-cart__button'
  ].join(',');

  const OPTION_CONTROL_SELECTOR = [
    '.mw-option__control',
    'input',
    'select',
    'button'
  ].join(',');

  function optionContainer() {
    return [...document.querySelectorAll('.mw-apo-container')].find(
      (container) =>
        !container.closest('.joa-express-form, .joa-quick-ring, .mw-tingle') &&
        container.querySelector('[name^="mw_opts["]')
    ) || null;
  }

  function apoIsReady() {
    const container = optionContainer();
    if (!container) return false;

    const groups = [...container.querySelectorAll(':scope > .mw-option')];
    if (!groups.length) return false;

    return groups.every((group) => group.querySelector(OPTION_CONTROL_SELECTOR));
  }

  function readinessState() {
    if (document.querySelector('.joa-earrings-product, .joa-bracelet-product, .joa-necklace-product')) return 'not-applicable';
    const html = document.documentElement;
    if (html.classList.contains('joa-express-active')) {
      return apoIsReady() ? 'ready' : 'loading';
    }
    return html.classList.contains('joa-express-booting')
      ? 'loading'
      : 'not-applicable';
  }

  function syncReadiness() {
    const state = readinessState();
    const loading = state === 'loading';
    document.body?.classList.toggle('joa-options-are-loading', loading);
    document.body?.classList.toggle('joa-options-are-ready', !loading);
    let notice = document.querySelector('.joa-options-loading');
    if (!loading) {
      clearTimeout(slowTimer);
      slowTimer = null;
      delayed = failed = false;
      notice?.remove();
      return;
    }
    if (!slowTimer && !delayed) slowTimer = setTimeout(() => {
      slowTimer = null;
      delayed = true;
      syncReadiness();
    }, 15000);

    const form = optionContainer()?.closest('form') ||
      document.querySelector('#MainContent .shopify-product-form:not(.joa-express-form)') ||
      document.querySelector('#MainContent form[action*="/cart/add"]:not(.joa-express-form)');
    if (!form) return;
    if (!notice?.querySelector('[data-joa-options-message]')) {
      notice?.remove();
      notice = document.createElement('div');
      notice.className = 'joa-options-loading';
      notice.innerHTML = '<span class="joa-options-loading__spinner" aria-hidden="true"></span>' +
        '<span role="status" aria-live="polite" data-joa-options-message></span>' +
        '<button type="button" class="joa-options-retry" hidden>Retry options</button>';
      // Reload only on an explicit tap. This cancels stalled requests without
      // initializing a second APO instance or changing the saved Shopify cart.
      notice.querySelector('button').addEventListener('click', () => {
        if (readinessState() === 'loading') window.location.reload();
      });
      form.insertBefore(notice, form.querySelector(':scope > .product-form-buttons'));
    }
    const message = failed
      ? 'Your ring options could not load. Please retry.'
      : delayed ? 'Your ring options are taking longer to load. You can wait or retry.'
      : 'Preparing your ring customizations…';
    const label = notice.querySelector('[data-joa-options-message]');
    if (label.textContent !== message) label.textContent = message;
    notice.querySelector('button').hidden = !delayed && !failed;
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(ACTION_SELECTOR);
    if (!button || readinessState() !== 'loading') return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  // Keyboard submission must be gated too; a failed options request must never
  // submit the base ring without its configuration.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (readinessState() !== 'loading' || !form.matches?.('form[action*="/cart/add"]') ||
        form.closest('.joa-quick-ring, .mw-tingle')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    syncReadiness();
  }, true);

  document.addEventListener('joa:apo', ({ detail }) => {
    if (detail?.name !== 'initialize::options::request::failed' ||
        String(detail.payload?.productId) !== String(window.mwApoInit?.product?.id)) return;
    failed = true;
    syncReadiness();
  });
  window.JoaOptionsReadiness = { sync: syncReadiness, state: readinessState };

  let readinessFrame = 0;
  const observer = new MutationObserver(() => {
    if (readinessFrame) return;
    readinessFrame = requestAnimationFrame(() => {
      readinessFrame = 0;
      syncReadiness();
    });
  });
  observer.observe(document.querySelector('#MainContent') || document.body, { childList: true, subtree: true });

  document.addEventListener('joa:apo-statechange', syncReadiness);
  document.addEventListener('DOMContentLoaded', syncReadiness, { once: true });
  window.addEventListener('pageshow', syncReadiness);
  syncReadiness();
})();

